import { Brands, Reveal } from "./slideBits";

/**
 * Slide «Om meg»: portrett til venstre, namn, rolle og tre stasjonar til høgre (same komposisjon som i ET-dekket, med
 * Stord-blå aksent). Tekst på nynorsk.
 */
const ROLES = [
  { org: "Adonis AS", title: "Direktør for forretningsutvikling", years: "10 år", text: "Produkt, digitalisering og nye forretningsområde" },
  { org: "DigiHome", title: "Medgründer og CTO", text: "KI-plattform for bustadforvaltning" },
  { org: "Kviteberg AS", title: "Rådgjevar og utviklar", text: "Digitalisering og interne driftssystem" },
];

export default function AboutSlide() {
  return (
    <div className="pres-slide-inner flex flex-col" data-testid="pres-slide-om-meg">
      <Brands />
      <div className="pres-about">
        <div className="pres-about-photo-wrap pres-in" style={{ "--i": 1 }}>
          <img src="/brand/martin-kviteberg-portrett.jpg" alt="Martin Kviteberg" className="pres-about-photo" draggable={false} data-testid="pres-about-photo" />
        </div>
        <div className="pres-about-text">
          <h1 className="pres-h1 pres-h1-slide pres-about-name" data-testid="pres-about-name"><Reveal i={0}>Martin Kviteberg</Reveal></h1>
          <p className="pres-lead pres-in" style={{ "--i": 2 }}>Forretningsutvikling og teknologi</p>
          <ol className="pres-about-roles" data-testid="pres-about-roles">
            {ROLES.map((r, i) => (
              <li key={r.org} className="pres-about-role pres-in" style={{ "--i": 5 + i }} data-testid={`pres-about-role-${i}`}>
                <div className="pres-about-org">{r.org}</div>
                <div className="pres-about-title">{r.title}{r.years && <span className="pres-about-years"> · {r.years}</span>}</div>
                <div className="pres-about-desc">{r.text}</div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}
